import {Action, combineReducers} from "redux";
import {isType} from "typescript-fsa";

import {Ganymede} from "@slices/Ganymede/UserManager";
import {Permissions} from "@slices/Permissions/Permissions";

import {loadingReducer} from "src/utils/reducers";

import {
  searchProviderChanged, searchTextChanged, getUsers, userClicked,
  userDialogClosed, getUserPermissions, togglePermission,
} from "./Users.actions";


const searchProvider = (state: string = '', action: Action): string => {
  if (isType(action, searchProviderChanged))
    return action.payload;

  return state;
};

const searchText = (state: string = '', action: Action): string => {
  if (isType(action, searchTextChanged))
    return action.payload;

  return state;
};

const users = (state: Ganymede.User[] | null = null,
               action: Action): Ganymede.User[] | null => {
  if (isType(action, getUsers.started))
    return null;

  if (isType(action, getUsers.done))
    return action.payload.result;

  return state;
};

const isUnknownProvider = (state: boolean = false,
                           action: Action): boolean => {
  if (isType(action, getUsers.failed) &&
      (action.payload.error instanceof Ganymede.UnknownDomain))
    return true;

  if (isType(action, getUsers.started))
    return false;

  return state;
};

const isLoading = loadingReducer(getUsers);

const selectedUserRow = (state: number | null = null,
                         action: Action): number | null => {
  if (isType(action, userClicked))
    return action.payload.row;

  if (isType(action, userDialogClosed))
    return null;

  return state;
};

const selectedUserPermissions = (
  state: Permissions.AbstractPermission[] | null = null,
  action: Action,
): Permissions.AbstractPermission[] | null => {
  if (isType(action, getUserPermissions.done))
    return action.payload.result;

  if (isType(action, togglePermission.done))
    return action.payload.result;

  if (isType(action, userDialogClosed))
    return null;

  return state;
};

const pendingPermissions = (state: {[typeId: string]: boolean} = {},
                            action: Action): {[typeId: string]: boolean} => {
  if (isType(action, togglePermission.started)) {
    const {typeId, granted} = action.payload;

    return {...state, [typeId]: granted};
  }

  if (isType(action, togglePermission.done) ||
      isType(action, togglePermission.failed)) {
    const nextState = {...state};

    delete nextState[action.payload.params.typeId];

    return nextState;
  }

  return state;
};


export interface UsersState {
  searchProvider: string;
  searchText: string;
  users: Ganymede.User[] | null;
  isUnknownProvider: boolean;
  isLoading: boolean;
  selectedUserRow: number | null;
  selectedUserPermissions: Permissions.AbstractPermission[] | null;
  pendingPermissions: {[typeId: string]: boolean};
}

export default combineReducers<UsersState>({
  searchProvider,
  searchText,
  users,
  isUnknownProvider,
  isLoading,
  selectedUserRow,
  selectedUserPermissions,
  pendingPermissions,
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/users/reducer.ts